import React, { lazy } from "react";

import { Close } from "@mui/icons-material";
import { Box, Button, Card, IconButton, Typography } from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { setActionButtonToggle as setActionButtonToggleAction } from "../../redux/slices/authSlice";

const InterviewAssessments = lazy(() =>
  import("../../components/Assessments/InterviewAssessments")
);

/* ============================================================================
<Assessments />
============================================================================= */
const Assessments = ({
  isModal,
  onSelect,
  onClose,
  setActionButtonToggle,
  company,
}) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ p: 1.5, height: "95%", borderRadius: "10px" }}>
      <Box
        sx={{
          py: 1.5,
          px: 2,
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "10px",
          background: "#9048FB",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          color="white"
          fontWeight={500}
          fontSize={{ xs: "14px", md: "18px" }}
        >
          Select interview assessment
        </Typography>

        {isModal ? (
          <IconButton
            size="small"
            sx={{ bgcolor: "white", ":hover": { bgcolor: "white" } }}
            onClick={onClose}
          >
            <Close />
          </IconButton>
        ) : (
          {
            /* <Button
            variant="outlined"
            sx={{
              color: "white",
              borderColor: "white",
              borderRadius: "30px",
              px: 3,
              py: 1,
              border: 2,
            }}
            onClick={() => {
              if (!company) {
                setActionButtonToggle(true);
                console.log("No company data, possibly logged out.");
                return;
              }
              navigate("create");
            }}
          >
            Create new
          </Button> */
          }
        )}
      </Box>
      {/* <Suspense fallback={<SuspenseLoading width="100%" height="80%" />}> */}
      <InterviewAssessments
        isModal={isModal}
        onSelect={onSelect}
        onClose={onClose}
      />
      {/* </Suspense> */}
    </Card>
  );
};

const mapStateToProps = (state) => ({
  isUserCompanySetup: state.auth?.user?.company_id,
  company: state.company.company,
});

const mapDispatchToProps = {
  setActionButtonToggle: setActionButtonToggleAction,
};

/* Export
============================================================================= */

export default connect(mapStateToProps, mapDispatchToProps)(Assessments);
